import * as React from "react";

import { renderToggleButton_unstable } from "@fluentui/react-button";

import { RibbonToggleButtonInternalProps } from "../RibbonToggleButton.props";
import { useRibbonToggleButton } from "./useRibbonToggleButton";
import { useRibbonToggleButtonStyles } from "./useRibbonToggleButtonStyles";
import { RibbonToggleButtonProps } from "./RibbonToggleButton.types";

export const RibbonToggleButton = React.memo(
  React.forwardRef<HTMLButtonElement, RibbonToggleButtonInternalProps>(
    (props, ref) => {
      const state = useRibbonToggleButton(
        {
          ...props,
          size: props.size?.toLowerCase() as RibbonToggleButtonProps["size"],
        } as RibbonToggleButtonProps,
        ref
      );

      useRibbonToggleButtonStyles(state);

      return renderToggleButton_unstable(state);
    }
  )
);

RibbonToggleButton.displayName = "next/RibbonToggleButton";
